// Generated by LiveScript 1.6.0
var foldl, getValue, setupObserver;
foldl = require('./fn').foldl;
getValue = function(ctx, key){
  var ref$, obj, parent, prop;
  if (ctx.data == null) {
    return {
      value: void 8,
      parent: null,
      prop: ''
    };
  }
  ref$ = foldl(function(acc, prop){
    switch (false) {
    case acc.obj != null:
      return acc;
    default:
      return {
        obj: Reflect.get(acc.obj, prop, acc.obj),
        parent: acc.obj,
        prop: prop
      };
    }
  }, {
    obj: ctx.data,
    parent: null,
    prop: ''
  })(
  key.split('.')), obj = ref$.obj, parent = ref$.parent, prop = ref$.prop;
  return {
    value: obj,
    parent: parent,
    prop: prop
  };
};
setupObserver = function(ctx){
  var obs;
  if (ctx.observer != null) {
    return;
  }
  try {
    obs = new MutationObserver(function(){});
    obs.observe(document, {
      childList: true,
      subtree: true
    });
    return ctx.observer = obs;
  } catch (e$) {}
};
module.exports = {
  getValue: getValue,
  setupObserver: setupObserver
};